import { apiClient } from './client';
import type { BaseResponse } from '@/types/api';

export interface StationsData {
  stations: string[];
}

export async function fetchStations(): Promise<StationsData> {
  const res = await apiClient.get<BaseResponse<StationsData>>('/stations');
  return res.data.data;
}

export async function unbindStation(stationLabel: string): Promise<void> {
  await apiClient.post(`/stations/${encodeURIComponent(stationLabel)}/unbind`);
}
